"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.initials = exports.pluralize = exports.joinWithFinalSeparator = exports.escapeRegExp = exports.joinNames = exports.splitName = exports.possessive = void 0;
var lodash_1 = __importDefault(require("lodash"));
var pluralize_1 = __importDefault(require("pluralize"));
var possessive = function (str, fallback) {
    if (fallback === void 0) { fallback = ""; }
    if (!str)
        return fallback;
    return str.endsWith("s") ? str + "'" : str + "'s";
};
exports.possessive = possessive;
/*
 * Naive Name splitting to be used.
 */
var splitName = function (name) {
    var _a = lodash_1["default"].split(name || "", " "), firstName = _a[0], lastNameParts = _a.slice(1);
    var lastName = lodash_1["default"].join(lastNameParts, " ");
    return {
        firstName: firstName,
        lastName: lastName
    };
};
exports.splitName = splitName;
/*
 * Join first and last names, and trim whitespace
 */
var joinNames = function (firstName, lastName) {
    return ((firstName !== null && firstName !== void 0 ? firstName : "") + " " + (lastName !== null && lastName !== void 0 ? lastName : "")).trim();
};
exports.joinNames = joinNames;
// Stolen straight from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
var escapeRegExp = function (toBeEscaped) {
    return toBeEscaped.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}; // $& means the whole matched string
exports.escapeRegExp = escapeRegExp;
/*
 * Join the elements in an javascript array,
 * but let the last separator be different eg: `and` / `or`
 * Stackoverflow link: http://stackoverflow.com/questions/15069587/is-there-a-way-to-join-the-elements-in-an-js-array-but-let-the-last-separator-b
 * Credit: Chris Barr - http://stackoverflow.com/users/79677/chris-barr
 */
var joinWithFinalSeparator = function (values, separator, finalSeparator) {
    if (values === void 0) { values = []; }
    if (separator === void 0) { separator = ", "; }
    if (finalSeparator === void 0) { finalSeparator = " & "; }
    var outStr = "";
    if ((values === null || values === void 0 ? void 0 : values.length) === 1) {
        outStr = values[0];
    }
    else if (values.length === 2) {
        // joins all with only final separator
        outStr = lodash_1["default"].join(values, finalSeparator);
    }
    else if (values.length > 2) {
        // joins all with separator and using final separator
        outStr = "" + values
            .slice(0, -1)
            .join(separator) + finalSeparator + values.slice(-1);
    }
    return outStr;
};
exports.joinWithFinalSeparator = joinWithFinalSeparator;
var pluralize = function (word, length, inclusive) {
    if (inclusive === void 0) { inclusive = true; }
    return (0, pluralize_1["default"])(word, length, inclusive);
};
exports.pluralize = pluralize;
var initials = function (fullName) {
    var names = (0, exports.splitName)(fullName);
    return "" + names.firstName[0] + names.lastName[0];
};
exports.initials = initials;
//# sourceMappingURL=strings.js.map